<template>
  <div>
    <serveur-info :erreur="error" />
    <my-notification v-if="authStore.isAuthenticated" :icon="icon">
      <template #title>
        {{ $t('compCarbonFormsFoodsMain.title') }}
      </template>
      {{ $t('compCarbonFormsFoodsMain.info-1') }}
    </my-notification>
    <my-notification v-else :icon="icon">
      <template #title>
        {{ $t('compCarbonFormsFoodsMain.title') }}
      </template>
      <span v-html="$t('compCarbonFormsFoodsMain.info-2')"></span>
      <br />
      <br />
      {{ $t('compCarbonFormsFoodsMain.info-3') }}
    </my-notification>
    <br v-if="authStore.isAuthenticated" />

    <survey-config v-if="authStore.isAuthenticated" />

    <br />
    <covid-information :year="year" />
    <br v-if="year === 2020 || year === 2021" />

    <statistics-box :isCommute="false" />

    <food-table
      :editable="!authStore.isAuthenticated"
      @update="$emit('is-modified', true)"
      @del="del"
      data-testId="food-table"
    />

    <br />
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="buttons">
          <b-button
            v-if="!authStore.isAuthenticated"
            :disabled="isSubmitted"
            class="button"
            icon-left="plus"
            @click="displayAddForm"
            data-testid="food-add"
          >
            {{ $t('add') }}
          </b-button>
          <b-button
            v-if="authStore.isAuthenticated"
            class="level-item"
            icon-left="download"
            @click="exportFoods"
          >
            {{ $t('export') }}
          </b-button>
          <b-button
            class="level-item"
            :icon-left="validSavedIcon"
            :disabled="!flags.isModified"
            type="is-primary"
            @click="validate"
            data-testid="food-save"
          >
            <span v-if="authStore.isAuthenticated">{{ $t('save') }}</span>
            <span v-else>{{ $t('validate') }}</span>
          </b-button>
        </div>
      </div>
    </nav>

    <b-modal
      :active.sync="displayModal"
      has-modal-card
      :can-cancel="['escape', 'x', 'outside']"
      :width="1000"
    >
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compCarbonFormsFoodsMain.field-1') }}
          </p>
        </header>
        <section class="modal-card-body">
          <survey-form
            v-show="!surveySubmitted && !foodSubmitted"
            v-model="food"
            :isSurvey="false"
            :year="year"
            :totalStep="totalStep"
            @submit="submitSurvey"
          />
          <food-form
            v-show="surveySubmitted && !foodSubmitted"
            v-model="food"
            :isSurvey="false"
            :startStep="startStep"
            :totalStep="totalStep"
            :year="year"
            :isSimulation="false"
            @submit="add"
            @back="surveySubmitted = false"
          />
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Modules from '@/models/Modules.js'
import Food from '@/models/carbon/Food.js'
import { createExportFile } from '@/utils/files'
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useCoreStore } from '@/stores/core.js'

import _ from 'lodash'

export default {
  name: 'Main',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'statistics-box': () =>
      import('@/components/carbon/forms/survey/StatisticsBox.vue'),
    'food-table': () => import('@/components/carbon/forms/foods/Table.vue'),
    'survey-form': () => import('@/components/carbon/forms/survey/Form.vue'),
    'food-form': () => import('@/components/carbon/forms/foods/Form.vue'),
    'survey-config': () =>
      import('@/components/carbon/forms/survey/SurveyConfig.vue'),
    'covid-information': () =>
      import('@/components/carbon/forms/survey/CovidInformation.vue')
  },
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    flags: {
      type: Object
    }
  },
  data () {
    return {
      error: '',
      food: Food.createEmpty(),
      displayModal: false,
      surveySubmitted: false,
      foodSubmitted: false,
      icon: Modules.getIcon(Modules.FOODS)
    }
  },
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    const ghgiStore = useGHGIStore()
    const coreStore = useCoreStore()
    return { adminStore, coreStore, authStore, ghgiStore }
  },
  computed: {
    module: function () {
      return Modules.FOODS
    },
    isEditable: function () {
      return !this.authStore.isAuthenticated
    },
    validSavedIcon: function () {
      let icon = null
      if (this.authStore.isAuthenticated) {
        icon = 'save'
      } else {
        icon = 'check'
      }
      return icon
    },
    foods: function () {
      return this.ghgiStore.items(Modules.FOODS)
    },
    year: function () {
      return this.ghgiStore.item.year
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    },
    positions () {
      return this.coreStore.surveyPositionTitles.map((x) => x.name)
    },
    startStep () {
      if (this.positions.length === 1) {
        return 2
      } else {
        return 3
      }
    },
    totalStep: function () {
      let totalStep = 4
      if (this.food.nWorkingDay === 0) {
        totalStep = 2
      }
      if (this.positions.length === 1) {
        totalStep -= 1
      }
      return totalStep
    }
  },
  methods: {
    validate: function () {
      if (this.authStore.isAuthenticated) {
        const loadingComponent = this.$buefy.loading.open({
          container: null
        })
        this.ghgiStore
          .saveItems(Modules.FOODS)
          .then((data) => {
            loadingComponent.close()
            this.$emit('is-valid', true)
            this.error = ''
            this.$emit('is-modified', false)
            window.scrollTo(0, 0)
            this.$buefy.toast.open({
              type: 'is-light',
              message: this.$t('compCarbonFormsFoodsMain.save-msg')
            })
          })
          .catch((erreur) => {
            loadingComponent.close()
            this.$emit('is-valid', false)
            this.error = erreur.response.data
          })
      } else {
        this.$emit('is-valid', true)
        this.$emit('is-modified', false)
      }
    },
    submitSurvey: function () {
      if (this.food.nWorkingDay === 0) {
        this.add()
      } else {
        this.surveySubmitted = true
      }
    },
    add: function () {
      this.food = Food.createFromObj(this.food)
      this.food.clean()
      this.ghgiStore.addItem({
        module: Modules.FOODS,
        item: this.food
      })
      this.displayModal = false
      this.surveySubmitted = false
      this.foodSubmitted = false
      this.food = Food.createEmpty()
      this.$emit('is-modified', true)
    },
    del: function (items) {
      this.$emit('is-modified', true)
      if (this.isEditable) {
        this.ghgiStore.deleteItems({
          module: this.module,
          items: items
        })
      } else {
        for (let item of items) {
          let nitem = _.cloneDeep(item)
          nitem.mdeleted = !item.mdeleted
          this.ghgiStore.updateItem({
            module: Modules.FOODS,
            item: {
              from: item,
              to: nitem
            }
          })
        }
      }
    },
    displayAddForm: function () {
      let seqID = this.foods.length + 1
      this.food = Food.createEmpty()
      this.food.seqID = 'u' + seqID
      this.displayModal = true
    },
    exportFoods: function () {
      this.ghgiStore.compute()
      let content = Food.exportToFile(this.foods)
      createExportFile(content, 'ghgi' + this.year + '_foods')
    }
  }
}
</script>
